<div class="container-fluid" style="width:100%;">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>

  <!--Form structure-->
  <div class="row" style="margin-top:5px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">
      <form class="container frm-top" style="width:100%;" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">

        <div class="row">
          <div class="col-12 text-left ln-sp form-inline">
            <label class="control-label hd-cat">
              <strong>&nbsp;&nbsp; Please Select Customer Type<a class="red-asterik"> *</a>&nbsp;&nbsp;</strong>
            </label>
            <select class="form-control form-control-sm" style="width:40%!important;" id="carrier_type"
                    [(ngModel)]="carrierType" (change)="onChange('change')" name="carrier_type_id"
                    formControlName="carrier_type_id"
                    [ngClass]="{'error': form.controls.carrier_type_id.invalid  && form.controls.carrier_type_id.dirty , 'noerror': form.controls.carrier_type_id.valid  && form.controls.carrier_type_id.dirty}"
                    title="">
              <!-- <option value="" disabled selected>Select customer type</option> -->
              <ng-container *ngFor="let cType of sortBy('desc')">
                <option *ngIf="cType.is_active" [ngValue]="cType.id">{{cType.desc}}</option>
              </ng-container>
            </select>
            <div class="form-control-feedback text-danger text-small"
                 *ngIf="form.controls.carrier_type_id.invalid && form.controls.carrier_type_id.dirty">
              <p *ngIf="form.controls.carrier_type_id.errors.required">* Required</p>
            </div>
          </div>
        </div>

        <!--Company details-->
        <div class="card border-light shadow-sm">
          <input type="hidden" name="id_type_ind" formControlName="id_type_ind" />
          <label class="control-label hd-cat">
            <strong>Carrier Account</strong>
          </label>

          <!--Carrier and business types-->
          <div class="row" *ngIf="whichCarrierType==2">

            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Country<a class="red-asterik"> *</a>
              </label>
              <select class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()" id="country_id" name="country_id"
                      formControlName="country_id"
                      [ngClass]="{'error': form.controls.country_id.invalid  && form.controls.country_id.dirty , 'noerror': form.controls.country_id.valid  && form.controls.country_id.dirty}"
                      title="Country that the company is based in.">
                <option value="" disabled selected>Select country</option>
                <option *ngFor="let country of ddlCountries" [ngValue]="country.id">{{country.desc}}</option>
              </select>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.country_id.invalid && form.controls.country_id.dirty">
                <p *ngIf="form.controls.country_id.errors.required">* Required</p>
              </div>
            </div>

            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Company Registered Name<a class="red-asterik"> *</a>
              </label>
              <input type="text" name="registered_name" formControlName="registered_name"
                     class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.registered_name.invalid  && form.controls.registered_name.dirty , 'noerror': form.controls.registered_name.valid  && form.controls.registered_name.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.registered_name.invalid && form.controls.registered_name.dirty">
                <p *ngIf="form.controls.registered_name.errors.required">* Required</p>
                <p *ngIf="form.controls.registered_name.errors.maxlength">
                  No more than 100 characters allowed for
                  Company Registered Name.
                </p>
              </div>
            </div>

            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Trading Name
              </label>
              <input type="text" name="trading_name" formControlName="trading_name"
                     class="form-control input-sm form-control-sm"
                     [ngClass]="{'error': form.controls.trading_name.invalid  && form.controls.trading_name.dirty , 'noerror': form.controls.trading_name.valid  && form.controls.trading_name.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.trading_name.invalid && form.controls.trading_name.dirty">
                <p *ngIf="form.controls.trading_name.errors.maxlength">
                  No more than 100 characters allowed for Trading
                  Name.
                </p>
              </div>
            </div>

            <div class="col-6 sp-fld ">
              <!-- Closed Corporation Reg No
                   Company Registration Number -->
              <label class="control-label hd-cat lbl-align">
                {{id_label}}<a class="red-asterik"> *</a>
              </label>
              <input type="text" name="registration_number" formControlName="registration_number"
                     class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                     (keyup)="preValidateRegNumber('captureRegNumber')"
                     [ngClass]="{'error': form.controls.registration_number.invalid  && form.controls.registration_number.dirty , 'noerror': form.controls.registration_number.valid  && form.controls.registration_number.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.registration_number.invalid && form.controls.registration_number.dirty">
                <p *ngIf="form.controls.registration_number.errors.required">*Required</p>
                <p *ngIf="form.controls.registration_number.errors.length">No more than 20 characters allowed</p>
              </div>
            </div>

            <!--Company common extra-->
            <div class="col-6 sp-fld">
              <label class="control-label hd-cat lbl-z">
                Type of Carrier<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" (change)="changeBasicContactInfoParm()" id="freight_passenger_ind" name="freight_passenger_ind" #typeCarrier
                      formControlName="freight_passenger_ind"
                      [ngClass]="{'error': form.controls.freight_passenger_ind.invalid  && form.controls.freight_passenger_ind.dirty , 'noerror': form.controls.freight_passenger_ind.valid  && form.controls.freight_passenger_ind.dirty}"
                      title="">
                <option *ngFor="let cType of utility.freight_passenger_inds" [ngValue]="cType.key">
                  {{cType.value}}
                </option>
              </select>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.freight_passenger_ind.invalid && form.controls.freight_passenger_ind.dirty">
                <p *ngIf="form.controls.freight_passenger_ind.errors.required">* Required</p>
              </div>
            </div>

            <!-- <div class="col-6 sp-fld" style="margin-top:4px!important;" *ngIf="!hasBusinessType()">
              <label class="control-label hd-cat lbl-z">
                Type of Business<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" (change)="changeBasicContactInfoParm()" id="business_type_id" name="business_type_id"
                      formControlName="business_type_id"
                      [ngClass]="{'error': form.controls.business_type_id.invalid  && form.controls.business_type_id.dirty , 'noerror': form.controls.business_type_id.valid  && form.controls.business_type_id.dirty}"
                      title="">
                <option *ngFor="let bType of utility.businessTypes" [ngValue]="bType.key">{{bType.value}}</option>
              </select>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.business_type_id.invalid && form.controls.business_type_id.dirty">
                <p *ngIf="form.controls.business_type_id.errors.required">*Required</p>
              </div>
            </div> -->

            <!--Company Common fields-->
            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Email Address
              </label>
              <input formControlName="Contact_CompanyEmail" class="form-control form-control-sm" type="text" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.Contact_CompanyEmail.invalid  && form.controls.Contact_CompanyEmail.dirty , 'noerror': form.controls.Contact_CompanyEmail.valid  && form.controls.Contact_CompanyEmail.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.Contact_CompanyEmail.invalid && form.controls.Contact_CompanyEmail.dirty">
                <p *ngIf="form.controls.Contact_CompanyEmail.errors.required">* Required</p>
                <p *ngIf="form.controls.Contact_CompanyEmail.errors.pattern">Invalid Email address</p>
              </div>
            </div>
            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Office Number
              </label>
              <ngx-intl-tel-input [cssClass]="'form-control form-control-sm'"
                                  [preferredCountries]="utility.preferredCountries" [enableAutoCountrySelect]="true"
                                  [enablePlaceholder]="true" [searchCountryFlag]="true"
                                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                                  [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true"
                                  [selectedCountryISO]="defaultCarrierOfficePhone" [separateDialCode]="separateDialCode"
                                  (countryChange)="ChangeCountry($event)" name="officePhone" formControlName="officePhone">
              </ngx-intl-tel-input>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.officePhone.invalid && form.controls.officePhone.dirty">
                <p>* Invalid Telephone Number</p>
              </div>
            </div>
            <div class="col-6 sp-fld">
              <label class="control-label hd-cat lbl-align">
                Mobile Number
              </label>
              <ngx-intl-tel-input [cssClass]="'form-control form-control-sm'"
                                  [preferredCountries]="utility.preferredCountries" [enableAutoCountrySelect]="true"
                                  [enablePlaceholder]="true" [searchCountryFlag]="true"
                                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                                  [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true"
                                  [selectedCountryISO]="defaultCarrierCellphone" [separateDialCode]="separateDialCode"
                                  (countryChange)="ChangeCountry($event,2)" name="cellphone" formControlName="cellphone">
              </ngx-intl-tel-input>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.cellphone.invalid && form.controls.cellphone.dirty">
                <p>* Invalid Mobile Number</p>
              </div>
            </div>
          </div>

          <!--  -->
          <div class="row" *ngIf="whichCarrierType==1">

            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Country<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="country_id" name="country_id"
                      formControlName="country_id"
                      [ngClass]="{'error': form.controls.country_id.invalid  && form.controls.country_id.dirty , 'noerror': form.controls.country_id.valid  && form.controls.country_id.dirty}"
                      title="Country that the company is based in.">
                <option value="" disabled selected>Select country</option>
                <option *ngFor="let country of ddlCountries" [ngValue]="country.id">{{country.desc}}</option>
              </select>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.country_id.invalid && form.controls.country_id.dirty">
                <p *ngIf="form.controls.country_id.errors.required">* Required</p>
              </div>
            </div>

            <div class="col-6 sp-fld">
              <label class="control-label hd-cat"></label>
            </div>

            <br>

            <div class="form-group col-6 sp-fld">
              <div class="form-inline">
                <label class="control-label" style="font-size:14px;color:darkblue;">
                  <input class="form-control form-control-sm ckbox" (change)="setCarrierPerson($event)" type="checkbox"
                         id="sameAsloggeIn" name="sameAsloggeIn" formControlName="sameAsloggeIn" title="">
                         &nbsp; Account is in the name of the person logged in
                </label>
                <span *ngIf="hasPerson" class="form-control-feedback text-info text-small">
                  Could not retrieve your First
                  Name and Last Name - Please type them below.
                </span>
                <div class="form-control-feedback text-danger text-small"
                     *ngIf="form.controls.sameAsloggeIn.invalid && form.controls.sameAsloggeIn.dirty">
                  <p *ngIf="form.controls.sameAsloggeIn.errors.required">* Required</p>
                </div>
              </div>
            </div>

            <div class="col-6 sp-fld">
              <label class="control-label hd-cat"></label>
            </div>

            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                First Name<a class="red-asterik"> *</a>
              </label>
              <input type="text" name="first_name" formControlName="first_name"
                     class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.first_name.invalid  && form.controls.first_name.dirty , 'noerror': form.controls.first_name.valid  && form.controls.first_name.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.first_name.invalid && form.controls.first_name.dirty">
                <p *ngIf="form.controls.first_name.errors.maxlength">No more than 50 characters allowed.</p>
                <p *ngIf="form.controls.first_name.errors.required">* Required</p>
              </div>
            </div>
            <div class="col-6 sp-fld">
              <label class="control-label hd-cat lbl-align">
                Last Name<a class="red-asterik"> *</a>
              </label>
              <input type="text" name="last_name" formControlName="last_name"
                     class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.last_name.invalid  && form.controls.last_name.dirty , 'noerror': form.controls.last_name.valid  && form.controls.last_name.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.last_name.invalid && form.controls.last_name.dirty">
                <p *ngIf="form.controls.last_name.errors.maxlength">No more than 50 characters allowed.</p>
                <p *ngIf="form.controls.last_name.errors.required">* Required</p>
              </div>
            </div>
            <div class="col-6 sp-fld">
              <label class="control-label hd-cat lbl-z">
                Type of Carrier<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" (change)="changeBasicContactInfoParm()" id="freight_passenger_ind" name="freight_passenger_ind" #typeCarrier
                      formControlName="freight_passenger_ind"
                      [ngClass]="{'error': form.controls.freight_passenger_ind.invalid  && form.controls.freight_passenger_ind.dirty , 'noerror': form.controls.freight_passenger_ind.valid  && form.controls.freight_passenger_ind.dirty}"
                      title="">
                <option *ngFor="let cType of utility.freight_passenger_inds" [ngValue]="cType.key">
                  {{cType.value}}
                </option>
              </select>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.freight_passenger_ind.invalid && form.controls.freight_passenger_ind.dirty">
                <p *ngIf="form.controls.freight_passenger_ind.errors.required">* Required</p>
              </div>
            </div>
            <!-- <div class="col-6 sp-fld" style="margin-top:4px!important;" *ngIf="!hasBusinessType()">
              <label class="control-label hd-cat lbl-z">
                Type of Business<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" (change)="changeBasicContactInfoParm()" id="business_type_id" name="business_type_id"
                      formControlName="business_type_id"
                      [ngClass]="{'error': form.controls.business_type_id.invalid  && form.controls.business_type_id.dirty , 'noerror': form.controls.business_type_id.valid  && form.controls.business_type_id.dirty}"
                      title="">
                <option *ngFor="let bType of utility.businessTypes" [ngValue]="bType.key">{{bType.value}}</option>
              </select>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.business_type_id.invalid && form.controls.business_type_id.dirty">
                <p *ngIf="form.controls.business_type_id.errors.required">*Required</p>
              </div>
            </div> -->

            <!--Extra fields-->
            <div class="col-6 sp-fld " *ngIf="isForeignId">
              <label class="control-label hd-cat lbl-align">
                Traffic Register Number (TRN)
              </label>
              <input type="text" name="traffic_register_number" formControlName="traffic_register_number"
                     class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.traffic_register_number.invalid  && form.controls.traffic_register_number.dirty , 'noerror': form.controls.traffic_register_number.valid  && form.controls.traffic_register_number.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.traffic_register_number.invalid && form.controls.traffic_register_number.dirty">
                <p *ngIf="form.controls.traffic_register_number.errors.required">* Required</p>
              </div>
            </div>
            <div class="col-6 sp-fld " *ngIf="isForeignId">
              <label class="control-label hd-cat lbl-align">
                Date of Issue of TRN
              </label>
              <input type="text"
              [ngModel]=" trn_issue_date" (ngModelChage)="trn_issue_date==$event"
               value="{{ trn_issue_date | date:'dd/MM/yyyy' }}"
              [placement]="'top'" container="body" ngbDatepicker #d1="ngbDatepicker"  (focus)="d1.toggle()"
              style="z-index: 9999 !important;"
              name="trn_issue_date" formControlName="trn_issue_date"
                class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                [ngClass]="{'error': form.controls.trn_issue_date.invalid  && form.controls.trn_issue_date.dirty , 'noerror': form.controls.trn_issue_date.valid  && form.controls.trn_issue_date.dirty}" />
                <i class="fa fa-calendar calendar-icon" (click)="d1.toggle()"></i> 
                <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.trn_issue_date.invalid && form.controls.trn_issue_date.dirty">
                <p *ngIf="form.controls.trn_issue_date.errors.required">* Required</p>
              </div>
            </div>
            <div class="col-6 sp-fld " *ngIf="isForeignId">
              <label class="control-label hd-cat lbl-align">
                Work Permit Reference Number
              </label>
              <input type="text" name="work_permit_number" formControlName="work_permit_number"
                     class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.work_permit_number.invalid  && form.controls.work_permit_number.dirty , 'noerror': form.controls.work_permit_number.valid  && form.controls.work_permit_number.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.work_permit_number.invalid && form.controls.work_permit_number.dirty">
                <p *ngIf="form.controls.work_permit_number.errors.required">* Required</p>
              </div>
            </div>
            <div class="col-6 sp-fld " *ngIf="isForeignId">
              <label class="control-label hd-cat lbl-align">
                Work Permit Expiry Date
              </label>
              <input type="text" name="work_permit_expiry_date"
              [placement]="'top'" container="body" ngbDatepicker #d2="ngbDatepicker"  (focus)="d2.toggle()"
              style="z-index: 9999 !important;"
              [ngModel]=" work_permit_expiry_date" (ngModelChage)="work_permit_expiry_date==$event"
                value="{{ work_permit_expiry_date | date:'yyyy/MM/dd' }}" formControlName="work_permit_expiry_date"
                class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                [ngClass]="{'error': form.controls.work_permit_expiry_date.invalid  && form.controls.work_permit_expiry_date.dirty , 'noerror': form.controls.work_permit_expiry_date.valid  && form.controls.work_permit_expiry_date.dirty}" />
                <i class="fa fa-calendar calendar-icon" (click)="d2.toggle()"></i> 
                <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.work_permit_expiry_date.invalid && form.controls.work_permit_expiry_date.dirty">
                <p *ngIf="form.controls.work_permit_expiry_date.errors.required">* Required</p>
              </div>
            </div>

            <!-- 
              [ngClass]="{'error': form.controls.id_number.invalid  && form.controls.id_number.dirty , 'noerror': form.controls.id_number.valid  && form.controls.id_number.dirty}"
              This piece of code displays the red line around an error field
             -->

            <div class="col-6 sp-fld ">
              <!-- ID Number
                   Foreign Passport / ID Number
                   Trust Registration Number
                   ID Number of Main Partner -->
              <label class="control-label hd-cat lbl-align">
                {{id_label}}<a class="red-asterik"> *</a>
              </label>
              <input type="text" name="id_number" formControlName="id_number" #id_number
                     class="form-control input-sm form-control-sm" (keyup)="preValidateID('captureID')" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.id_number.invalid  && form.controls.id_number.dirty , 'noerror': form.controls.id_number.valid  && form.controls.id_number.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.id_number.invalid && form.controls.id_number.dirty">
                <p *ngIf="form.controls.id_number.errors.required">* Required</p>
                <p *ngIf="form.controls.id_number.errors.saID"> Please provide a valid SA ID number</p>
              </div>
            </div>
            <div class="col-6 sp-fld " *ngIf="isForeignId">
              <label class="control-label hd-cat lbl-align">
                Country Of Issue<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" (change)="changeBasicContactInfoParm()" id="id_country_id" name="id_country_id"
                      formControlName="id_country_id" title="Indicates ID issued contry.">
                <option value="" disabled selected>Select country of issue</option>
                <option *ngFor="let idc of ddlCountries" [ngValue]="idc.id">{{idc.desc}}</option>
              </select>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.id_country_id.invalid && form.controls.id_country_id.dirty">
                <p *ngIf="form.controls.id_country_id.errors.required">* Required</p>
              </div>
            </div>
            <div class="col-6 sp-fld " *ngIf="isForeignId">
              <label class="control-label hd-cat lbl-align">
                Passport Expiry Date<a *ngIf="isForeignId && (passport_expiry_date=='' || passport_expiry_date==undefined)" class="red-asterik"> *</a>
              </label> 
              <input type="text"  [minDate]="currentDate" (keypress)="numbersOnly($event)" placeholder="dd/MM/yyyy" name="passport_expiry_date" [placement]="'top'" container="body" ngbDatepicker #d3="ngbDatepicker"  (focus)="d3.toggle()"
              class="form-control form-control-sm" formControlName="passport_expiry_date"
              [ngModel]="passport_expiry_date" (ngModelChage)="passport_expiry_date==$event"
               value="{{passport_expiry_date | date : 'dd/MM/yyyy'}}"
               [ngClass]="{'error':form.controls.passport_expiry_date.invalid && form.controls.passport_expiry_date.dirty, 'noerror': form.controls.passport_expiry_date.valid && form.controls.passport_expiry_date.dirty}"
               required="" style="z-index: 9999 !important;"/>
              <i class="fa fa-calendar calendar-icon" (click)="d3.toggle()"></i>             
              <!-- <input type="text" name="passport_expiry_date"
              [placement]="'top'" container="body" ngbDatepicker #d3="ngbDatepicker"  (focus)="d3.toggle()"
              style="z-index: 9999 !important;"
              [ngModel]="passport_expiry_date" (ngModelChage)="passport_expiry_date==$event"
              value="{{passport_expiry_date | date:'yyyy/MM/dd'}}"
                formControlName="passport_expiry_date" class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                [ngClass]="{'error': form.controls.passport_expiry_date.invalid  && form.controls.passport_expiry_date.dirty , 'noerror': form.controls.passport_expiry_date.valid  && form.controls.passport_expiry_date.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.passport_expiry_date.invalid && form.controls.passport_expiry_date.dirty">
                <p *ngIf="form.controls.passport_expiry_date.errors.required">*Required</p>
              </div> -->
            </div>

            <!--Common fields-->
            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Office Number
              </label>
              <ngx-intl-tel-input [cssClass]="'form-control form-control-sm'"
                                  [preferredCountries]="utility.preferredCountries" [enableAutoCountrySelect]="true"
                                  [enablePlaceholder]="true" [searchCountryFlag]="true"
                                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                                  [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true"
                                  [selectedCountryISO]="defaultCarrierOfficePhone" [separateDialCode]="separateDialCode"
                                  (countryChange)="ChangeCountry($event)" name="officePhone" formControlName="officePhone"
                                  style="z-index: 9999 !important;">
              </ngx-intl-tel-input>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.officePhone.invalid && form.controls.officePhone.dirty">
                <p>* Invalid Telephone Number</p>
              </div>
            </div>
            <div class="col-6 sp-fld">
              <label class="control-label hd-cat lbl-align">
                Mobile Number
              </label>
              <ngx-intl-tel-input #cellphone (focus)="$event.target.select()" (click)="$event.target.select()" [cssClass]="'form-control form-control-sm'"
                                  [preferredCountries]="utility.preferredCountries" [enableAutoCountrySelect]="true"
                                  [enablePlaceholder]="true" [searchCountryFlag]="true"
                                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                                  [maxLength]="15" [tooltipField]="TooltipLabel.Name" [phoneValidation]="true"
                                  [selectedCountryISO]="defaultCarrierCellphone" [separateDialCode]="separateDialCode"
                                  (countryChange)="ChangeCountry($event,2)" name="cellphone" formControlName="cellphone"
                                  style="z-index: 9999 !important;">
              </ngx-intl-tel-input>
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.cellphone.invalid && form.controls.cellphone.dirty">
                <p>* Invalid Mobile Number</p>
              </div>
            </div>
            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align">
                Email Address
              </label>
              <input #Contact_CompanyEmail (focus)="$event.target.select()" formControlName="Contact_CompanyEmail" class="form-control form-control-sm" type="text" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.Contact_CompanyEmail.invalid  && form.controls.Contact_CompanyEmail.dirty , 'noerror': form.controls.Contact_CompanyEmail.valid  && form.controls.Contact_CompanyEmail.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.Contact_CompanyEmail.invalid && form.controls.Contact_CompanyEmail.dirty">
                <p *ngIf="form.controls.Contact_CompanyEmail.errors.required">* Required</p>
                <p *ngIf="form.controls.Contact_CompanyEmail.errors.pattern">Invalid Email address</p>
              </div>
            </div>
          </div>

          <!--Contact details-->
          <br>
          <label class="control-label hd-cat">
            <strong>Contact Details</strong>
          </label>
          <div class="row">
            <div class="col-md-12" style="margin-bottom:5px;margin-top:5px">
              <div class="row">
                <div class="form-group col-md-12">
                  <div class="form-inline">
                    <label style="font-size:14px;color:darkblue;">
                      <input class="form-control ckbox" type="checkbox" id="contactSameAsloggeIn"
                             value="contactSameAsloggeIn" formControlName="contactSameAsloggeIn"
                             title="Same as person logged in" (click)="IsSameUser($event)">
                      <span style="margin-right:5px;">&nbsp; Contact person is the same as the person logged in</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label class="control-label hd-cat lbl-align">
                    First Name<a class="red-asterik"> *</a>
                  </label>
                  <input formControlName="Contact_FirstName" class="form-control form-control-sm" type="text"
                         [ngClass]="{'error': form.controls.Contact_FirstName.invalid  && form.controls.Contact_FirstName.dirty , 'noerror': form.controls.Contact_FirstName.valid  && form.controls.Contact_FirstName.dirty}" />
                  <div class="form-control-feedback text-danger text-small"
                       *ngIf="form.controls.Contact_FirstName.invalid && form.controls.Contact_FirstName.dirty">
                    <p *ngIf="form.controls.Contact_FirstName.errors.required">* Required</p>
                  </div>
                </div>
                <div class="form-group col-md-6 ">
                  <label class="control-label hd-cat lbl-align">
                    Last Name<a class="red-asterik"> *</a>
                  </label>
                  <input formControlName="Contact_LastName" class="form-control form-control-sm" type="text"
                         [ngClass]="{'error': form.controls.Contact_LastName.invalid  && form.controls.Contact_LastName.dirty , 'noerror': form.controls.Contact_LastName.valid  && form.controls.Contact_LastName.dirty}" />
                  <div class="form-control-feedback text-danger text-small"
                       *ngIf="form.controls.Contact_LastName.invalid && form.controls.Contact_LastName.dirty">
                    <p *ngIf="form.controls.Contact_LastName.errors.required">* Required</p>
                  </div>
                </div>
                <div class="form-group col-md-6 ">
                  <label class="control-label hd-cat lbl-align">
                    Email Address<a class="red-asterik"> *</a>
                  </label>
                  <input #Contact_EmailAddress (focus)="$event.target.select()" formControlName="Contact_EmailAddress" class="form-control form-control-sm" type="text" (change)="changeBasicContactInfoParm()"
                         [ngClass]="{'error': form.controls.Contact_EmailAddress.invalid  && form.controls.Contact_EmailAddress.dirty , 'noerror': form.controls.Contact_EmailAddress.valid  && form.controls.Contact_EmailAddress.dirty}" />
                  <div class="form-control-feedback text-danger text-small"
                       *ngIf="form.controls.Contact_EmailAddress.invalid && form.controls.Contact_EmailAddress.dirty">
                    <p *ngIf="form.controls.Contact_EmailAddress.errors.required">* Required</p>
                    <p *ngIf="form.controls.Contact_EmailAddress.errors.pattern">Invalid Email address</p>
                  </div>
                </div>
                <div class="form-group col-md-6 ">
                  <label class="control-label hd-cat lbl-align">
                    Mobile Number<a class="red-asterik"> *</a>
                  </label>
                  <!-- <input formControlName="Contact_MobileNumber" class="form-control form-control-sm" type="text" [ngClass]="{'error': form.controls.Contact_MobileNumber.invalid  && form.controls.Contact_MobileNumber.dirty , 'noerror': form.controls.Contact_MobileNumber.valid  && form.controls.Contact_MobileNumber.dirty}" /> -->
                  <ngx-intl-tel-input #Contact_MobileNumber (click)="$event.target.select()" [cssClass]="'form-control form-control-sm'"
                                      [preferredCountries]="utility.preferredCountries" [enableAutoCountrySelect]="true"
                                      [enablePlaceholder]="true" [searchCountryFlag]="true"
                                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                      [selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
                                      [phoneValidation]="true" [selectedCountryISO]="defaultContactMobile"
                                      [separateDialCode]="separateDialCode" (countryChange)="ChangeCountry($event,3)"
                                      name="Contact_MobileNumber" formControlName="Contact_MobileNumber">
                  </ngx-intl-tel-input>
                  <div class="form-control-feedback text-danger text-small"
                       *ngIf="form.controls.Contact_MobileNumber.invalid && form.controls.Contact_MobileNumber.dirty">
                    <p>* Invalid Mobile Number</p>
                  </div>
                </div>
                <div class="col-sm-6 ">
                  <label class="control-label hd-cat ">
                    Communication Preference<a class="red-asterik"> *</a>
                  </label>
                  <select class="form-control form-control-sm" formControlName="Contact_CommunicationPreference" (change)="selectCommunication(commun)"
                          #commun 
                          [ngClass]="{'error': form.controls.Contact_CommunicationPreference.invalid  && form.controls.Contact_CommunicationPreference.dirty , 'noerror': form.controls.Contact_CommunicationPreference.valid  && form.controls.Contact_CommunicationPreference.dirty}">
                    <option value="" disabled selected>Select communication preference</option>
                    <option value="Email" selected>Email</option>
                    <option value="SMS">SMS</option>
                  </select>
                  <div class="form-control-feedback text-danger text-small"
                        *ngIf="form.controls.Contact_CommunicationPreference.invalid && form.controls.Contact_CommunicationPreference.dirty">
                     <p *ngIf="form.controls.Contact_CommunicationPreference.errors.required">* Required</p>
                  </div>
                </div>
              </div>
            </div>

            <br>

            <div class="col-12" style="margin-bottom:5px;margin-top:5px">
              <div class="row">
                <div class="col-6">

                  <div class="row">
                    <div class="col-6 sp-fld">
                      <label class="control-label hd-cat"></label>
                    </div>

                    <br>

                    <div class="form-group col-md-12 " style="position: relative;margin-top:5px;">
                    <!-- <div class="form-group col-md-12 " style="position: relative;"> -->
                      <label class="control-label hd-cat lbl-align">
                        Physical Address<a class="red-asterik"> *</a>
                      </label>
                      <input #physicalAddressInput (keyup)="onPhysicalAddressChange(physicalAddressInput)"
                             maxlength="40"
                             (focus)="physicalAddressFocus()" (blur)="physicalAddressBlur()"
                             autocomplete="new-Contact_PhysicalAddress1" formControlName="Contact_PhysicalAddress1"
                             class="form-control form-control-sm" type="text"
                             [ngClass]="{'error': form.controls.Contact_PhysicalAddress1.invalid  && form.controls.Contact_PhysicalAddress1.dirty , 'noerror': form.controls.Contact_PhysicalAddress1.valid  && form.controls.Contact_PhysicalAddress1.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_PhysicalAddress1.invalid && form.controls.Contact_PhysicalAddress1.dirty">
                        <p *ngIf="form.controls.Contact_PhysicalAddress1.errors.required">
                          * Required
                        </p>
                      </div>
                      <div *ngIf="isPlacesPredictionVible" class="search-dropdown-content">
                        <div *ngFor="let place of placesPredictions" class="text-ellipsis" style="width: 100%;">
                          <div (click)="clickSearchedPlace(place)" style="z-index: 2;">
                            <i class="fa fa-map-marker map-icon"
                               style="font-size: 14px; margin-right: 5px;"></i>{{place.description}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-12 ">
                      <label class="control-label hd-cat lbl-align">
                        Town<a class="red-asterik"> *</a>
                      </label>
                      <input formControlName="Contact_Town" class="form-control form-control-sm" type="text"
                             maxlength="40"
                             [ngClass]="{'error': form.controls.Contact_Town.invalid  && form.controls.Contact_Town.dirty , 'noerror': form.controls.Contact_Town.valid  && form.controls.Contact_Town.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_Town.invalid && form.controls.Contact_Town.dirty">
                        <p *ngIf="form.controls.Contact_Town.errors.required">* Required</p>
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label class="control-label hd-cat lbl-align">
                        Postal Code<a class="red-asterik"> *</a>
                      </label>
                      <input formControlName="Contact_PostalCode" class="form-control form-control-sm" type="text"
                              maxlength="25" 
                             [ngClass]="{'error': form.controls.Contact_PostalCode.invalid  && form.controls.Contact_PostalCode.dirty , 'noerror': form.controls.Contact_PostalCode.valid  && form.controls.Contact_PostalCode.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_PostalCode.invalid && form.controls.Contact_PostalCode.dirty">
                        <p *ngIf="form.controls.Contact_PostalCode.errors.required">* Required</p>
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label class="control-label hd-cat lbl-align">
                        Country<a class="red-asterik"> *</a>
                      </label>
                      <select class="form-control form-control-sm" id="pCountry" name="Contact_CountryID"
                              formControlName="Contact_CountryID"
                              [ngClass]="{'error': form.controls.Contact_CountryID.invalid  && form.controls.Contact_CountryID.dirty , 'noerror': form.controls.Contact_CountryID.valid  && form.controls.Contact_CountryID.dirty}"
                              title="Country that the company is based in.">
                        <option value="" disabled selected>Select country</option>
                        <ng-container *ngFor="let country of ddlCountries">
                          <option *ngIf="country.is_active" [ngValue]="country.id">{{country.desc}}</option>
                        </ng-container>
                      </select>
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_CountryID.invalid && form.controls.Contact_CountryID.dirty">
                        <p *ngIf="form.controls.Contact_CountryID.errors.required">* Required</p>
                      </div>
                    </div>

                    <!-- <div style="margin-top:5px; margin-bottom:-5px;" class="form-inline">
                      <label style="margin-bottom:2px!important;margin-left:15px;font-size:14px;color:#1D3F94;font-size: 18px;" class="">
                        <input class="form-control form-control-sm ckbox" style="margin:0px;padding:0px; margin-right:10px;" type="checkbox"
                               id="copyPhysical_address" formControlName="copyPhysical_address" (click)="copyTo($event)">
                        <b>  Same as physical address</b>
                      </label>
                    </div> -->

                  </div>
                </div>

                <div class="col-6">

                  <div class="row">

                    <div style="margin-top:10px; margin-bottom:8px;" class="form-inline">
                         <label style="font-size:14px;color:darkblue;margin-left:15px;">
                          <input class="form-control form-control-sm ckbox" style="margin:0px;padding:0px; margin-right:10px;" type="checkbox"
                                 id="copyPhysical_address" formControlName="copyPhysical_address" (click)="copyTo($event)">
                                 Same as physical address
                        </label>
                    </div>

                  <!-- <div class="row mt-4"> -->
                    <div class="form-group col-md-12">
                      <label class="control-label hd-cat lbl-align">
                        Postal Address<a class="red-asterik"> *</a>
                      </label>
                      <input #postalAddressInput (keyup)="onPostalAddressChange(postalAddressInput)"
                             (focus)="postalAddressFocus()" (blur)="postalAddressBlur()"
                             maxlength="40" 
                             autocomplete="new-Contact_PostalAddress1" formControlName="Contact_PostalAddress1"
                             class="form-control form-control-sm" type="text"
                             [ngClass]="{'error': form.controls.Contact_PostalAddress1.invalid  && form.controls.Contact_PostalAddress1.dirty , 'noerror': form.controls.Contact_PostalAddress1.valid  && form.controls.Contact_PostalAddress1.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_PostalAddress1.invalid && form.controls.Contact_PostalAddress1.dirty">
                        <p *ngIf="form.controls.Contact_PostalAddress1.errors.required">* Required</p>
                      </div>
                      <div *ngIf="isPostalPlacesPredictionVible" class="search-dropdown-content">
                        <div *ngFor="let place of placesPostalPredictions" class="text-ellipsis" style="width: 100%;">
                          <div (click)="clickSearchedPlacePostal(place)" style="z-index: 2;">
                            <i class="fa fa-map-marker map-icon"
                               style="font-size: 14px; margin-right: 5px;"></i>{{place.description}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-12 ">
                      <label class="control-label hd-cat lbl-align">
                        Town<a class="red-asterik"> *</a>
                      </label>
                      <input formControlName="Contact_pTown" class="form-control form-control-sm" type="text"
                             maxlength="40" 
                             [ngClass]="{'error': form.controls.Contact_pTown.invalid  && form.controls.Contact_pTown.dirty , 'noerror': form.controls.Contact_pTown.valid  && form.controls.Contact_pTown.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_pTown.invalid && form.controls.Contact_pTown.dirty">
                        <p *ngIf="form.controls.Contact_pTown.errors.required">* Required</p>
                      </div>
                    </div>

                    <div class="form-group col-md-12 ">
                      <label class="control-label hd-cat lbl-align">
                        Postal Code<a class="red-asterik"> *</a>
                      </label>
                      <input formControlName="Contact_pPostalCode" class="form-control form-control-sm" type="text"
                              maxlength="25" 
                             [ngClass]="{'error': form.controls.Contact_pPostalCode.invalid  && form.controls.Contact_pPostalCode.dirty , 'noerror': form.controls.Contact_pPostalCode.valid  && form.controls.Contact_pPostalCode.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_pPostalCode.invalid && form.controls.Contact_pPostalCode.dirty">
                        <p *ngIf="form.controls.Contact_pPostalCode.errors.required">* Required</p>
                      </div>
                    </div>

                    <div class="form-group col-md-12 ">
                      <label class="control-label hd-cat lbl-align">
                        Country<a class="red-asterik"> *</a>
                      </label>
                      <select class="form-control form-control-sm" id="pCountry" name="pCountry"
                              formControlName="Contact_pCountry"
                              [ngClass]="{'error': form.controls.Contact_pCountry.invalid  && form.controls.Contact_pCountry.dirty , 'noerror': form.controls.Contact_pCountry.valid  && form.controls.Contact_pCountry.dirty}"
                              title="Country that the company is based in.">
                        <option value="" disabled selected>Select country</option>
                        <ng-container *ngFor="let country of ddlCountries">
                          <option *ngIf="country.is_active" [ngValue]="country.id">{{country.desc}}</option>
                        </ng-container>
                      </select>
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.Contact_pCountry.invalid && form.controls.Contact_pCountry.dirty">
                        <p *ngIf="form.controls.Contact_pCountry.errors.required">* Required</p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <!--<div class="row">
            <div class="form-group col-md-6 ">
              <label class="control-label hd-cat lbl-align">
                Fax Number
              </label>
              <input formControlName="Contact_FaxNumber" class="form-control form-control-sm" type="text" [ngClass]="{'error': form.controls.Contact_FaxNumber.invalid  && form.controls.Contact_FaxNumber.dirty , 'noerror': form.controls.Contact_FaxNumber.valid  && form.controls.Contact_FaxNumber.dirty}" />
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.Contact_FaxNumber.invalid && form.controls.Contact_FaxNumber.dirty">
                <p *ngIf="form.controls.Contact_FaxNumber.errors.required">*Required</p>
              </div>
            </div>
            <div class="form-group col-md-6 ">
              <label class="control-label hd-cat lbl-align">
                Office Phone
              </label>
              <ngx-intl-tel-input [cssClass]="'form-control form-control-sm'"
                                  [preferredCountries]="utility.preferredCountries"
                                  [enableAutoCountrySelect]="true"
                                  [enablePlaceholder]="true"
                                  [searchCountryFlag]="true"
                                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                  [selectFirstCountry]="false"
                                  [maxLength]="15"
                                  [tooltipField]="TooltipLabel.Name"
                                  [phoneValidation]="true"
                                  [selectedCountryISO]="defaultCountryPhone"
                                  [separateDialCode]="separateDialCode"
                                  (countryChange)="ChangeCountryPhone($event)"
                                  name="Contact_OfficePhone" formControlName="Contact_OfficePhone">
              </ngx-intl-tel-input>
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.Contact_OfficePhone.invalid && form.controls.Contact_OfficePhone.dirty">
                <p *ngIf="form.controls.Contact_OfficePhone.errors.required">*Required</p>
              </div>
            </div>
            <div class="form-group col-md-6 ">
              <label class="control-label hd-cat lbl-align">
                Company Email
              </label>
              <input formControlName="Contact_CompanyEmail" class="form-control form-control-sm" type="text" [ngClass]="{'error': form.controls.Contact_CompanyEmail.invalid  && form.controls.Contact_CompanyEmail.dirty , 'noerror': form.controls.Contact_CompanyEmail.valid  && form.controls.Contact_CompanyEmail.dirty}" />
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.Contact_CompanyEmail.invalid && form.controls.Contact_CompanyEmail.dirty">
                <p *ngIf="form.controls.Contact_CompanyEmail.errors.required">*Required</p>
              </div>
            </div>
          </div>-->

            </div>
          </div>
        </div>

        <!--Compliance and Legal-->
        <div class="card border-light shadow-sm">
          <label class="control-label hd-cat"><strong>Compliance and Legal</strong></label>

          <div class="row" *ngIf="is_local_carrier && carrierType!=1011">
            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align" >
                Tax Number<a *ngIf="!(carrierType===1011 || carrierType===1007)" class="red-asterik"> *</a>
              </label>
              <input type="text" name="tax_number" (keypress)="numbersOnly($event)" formControlName="tax_number"
                     class="form-control input-sm form-control-sm" (change)="changeBasicContactInfoParm()"
                     [ngClass]="{'error': form.controls.tax_number.invalid  && form.controls.tax_number.dirty , 'noerror': form.controls.tax_number.valid  && form.controls.tax_number.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.tax_number.invalid && form.controls.tax_number.dirty">
                <p *ngIf="form.controls.tax_number.errors.required">* Required</p>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="is_local_carrier && carrierType==1011">
            <div class="col-6 sp-fld ">
              <label class="control-label hd-cat lbl-align" >
                Tax Number
              </label>
              <input type="text" name="tax_number" (keypress)="numbersOnly($event)" formControlName="tax_number"
                     class="form-control input-sm form-control-sm"
                     [ngClass]="{'error': form.controls.tax_number.invalid  && form.controls.tax_number.dirty , 'noerror': form.controls.tax_number.valid  && form.controls.tax_number.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.tax_number.invalid && form.controls.tax_number.dirty">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 ln-sp ">
              <label class="control-label hd-cat lbl-align">
                Transport Association
              </label>
              <select class="form-control form-control-sm" [attr.disabled]="form.value['freight_passenger_ind']=='1' ? true : null" name="assoc_id" formControlName="assoc_id"
                      (change)="onItemChange()">
                <option value="" selected class="text-muted">{{trspassoc}}</option>
                <ng-container *ngFor="let assoc of listAssoc">
                  <option *ngIf="assoc.is_active" [ngValue]="assoc.id">{{assoc.desc}}</option>
                </ng-container>
              </select>
            </div>
          </div>
          <br>
        </div>

        <!-- Demographics -->
        <!-- <div class="card border-light shadow-sm" *ngIf="isShowDemographicFrame(carrierType)"> -->
        <div class="card border-light shadow-sm" *ngIf="this.displayDemographics">
          <label class="control-label hd-cat"><strong>Demographics</strong></label>

          <div class="row">
            <div class="col-6 ln-sp ">
              <label class="control-label hd-cat lbl-align">
                BBBEE Status<a *ngIf="isLocal" class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" (change)="changeBBEE(bbeeStatus.value)" #bbeeStatus formControlName="bbbee_status"
                      [ngClass]="{'error': form.controls.bbbee_status.invalid  && form.controls.bbbee_status.dirty , 'noerror': form.controls.bbbee_status.valid  && form.controls.bbbee_status.dirty}">
                <option value="" disabled selected value="null">Select BBBEE status</option>
                <option *ngFor="let bbbee of bbbees" [ngValue]="bbbee.text">{{bbbee.text}}</option>
              </select>
              <!-- <input type="text" class="form-control form-control-sm" name="bbbee_status" formControlName="bbbee_status" title="" [ngClass]="{'error':form.controls.bbbee_status.invalid && form.controls.bbbee_status.dirty, 'noerror': form.controls.bbbee_status.valid && form.controls.bbbee_status.dirty}">
            <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.bbbee_status.invalid && form.controls.bbbee_status.dirty">
              <p *ngIf="form.controls.bbbee_status.errors.maxlength">BBBEE status must not be more than 12 characters.</p>
            </div> -->
            </div>

            <div class="col-6 ln-sp">

              <label class="control-label ">
                BBBEE Certificate Expiry Date<a *ngIf="isLocal && form.value['bbbee_status']!='NonCompliant'" class="red-asterik"> *</a>
              </label>
              <!-- <input type="text" readonly [minDate]="currentDate" (keypress)="numbersOnly($event)"  name="bbbee_certficate_date" [placement]="'top'" container="body" ngbDatepicker #d="ngbDatepicker"  (focus)="d.toggle()" -->
              <input type="text"  [minDate]="currentDate" (keypress)="numbersOnly($event)" placeholder="dd/MM/yyyy" name="bbbee_certficate_date" [placement]="'top'" container="body" ngbDatepicker #d="ngbDatepicker"  (click)="d.toggle()"
              class="form-control form-control-sm" formControlName="bbbee_certficate_date"
              [ngModel]="bbbee_certficate_date" (ngModelChage)="bbbee_certficate_date==$event"
               value="{{bbbee_certficate_date | date : 'dd/MM/yyyy'}}"
               [ngClass]="{'error':form.controls.bbbee_certficate_date.invalid && form.controls.bbbee_certficate_date.dirty, 'noerror': form.controls.bbbee_certficate_date.valid && form.controls.bbbee_certficate_date.dirty}"
               required="" style="z-index: 9999 !important;"/>
              <i class="fa fa-calendar calendar-icon" (click)="d.toggle()"></i>

              <!-- <input type="date" class="form-control form-control-sm" name="bbbee_certficate_date"
                (keypress)="numbersOnly($event)"
                formControlName="bbbee_certficate_date" title="" value="{{ bbbee_certficate_date| date:'yyyy-MM-dd' }}"
                [ngClass]="{'error':form.controls.bbbee_certficate_date.invalid && form.controls.bbbee_certficate_date.dirty, 'noerror': form.controls.bbbee_certficate_date.valid && form.controls.bbbee_certficate_date.dirty}"> -->
              <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.bbbee_certficate_date.invalid && form.controls.bbbee_certficate_date.dirty">
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.bbbee_certficate_date.invalid && form.controls.bbbee_certficate_date.dirty">
                <p *ngIf="form.controls.bbbee_certficate_date.errors.required">*Required</p>
              </div>
            </div> -->
            </div>

          </div>

          <div class="row">

            <div class="col-6 ln-sp ">
              <label class="control-label hd-cat lbl-align">
                % Black Ownership<a *ngIf="isLocal  && form.value['bbbee_status']!='NonCompliant'" class="red-asterik"> *</a>
              </label>
              <input type="number" class="form-control form-control-sm" name="black_ownership" min="0"
                     (keypress)="numbersOnly($event)" formControlName="black_ownership" title=""
                     [ngClass]="{'error':form.controls.black_ownership.invalid && form.controls.black_ownership.dirty, 'noerror': form.controls.black_ownership.valid && form.controls.black_ownership.dirty}">
              <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.black_ownership.invalid && form.controls.black_ownership.dirty">
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.black_ownership.invalid && form.controls.black_ownership.dirty">
                <p *ngIf="form.controls.black_ownership.errors.required">*Required</p>
              </div>

            </div> -->
            </div>

            <div class="col-6 ln-sp ">
              <label class="control-label hd-cat lbl-align">
                % Female Ownership<a *ngIf="isLocal  && form.value['bbbee_status']!='NonCompliant'" class="red-asterik"> *</a>
              </label>
              <input type="number" class="form-control form-control-sm" name="female_ownership" min="0"
                     (keypress)="numbersOnly($event)" formControlName="female_ownership" title=""
                     [ngClass]="{'error':form.controls.female_ownership.invalid && form.controls.female_ownership.dirty, 'noerror': form.controls.female_ownership.valid && form.controls.female_ownership.dirty}">
              <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.female_ownership.invalid && form.controls.female_ownership.dirty">
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.female_ownership.invalid && form.controls.female_ownership.dirty">
                <p *ngIf="form.controls.female_ownership.errors.required">*Required</p>
              </div>

            </div> -->
            </div>

          </div>


          <div class="row">

            <div class="col-6 ln-sp ">
              <label class="control-label hd-cat lbl-align">
                % Disability Ownership<a *ngIf="isLocal  && form.value['bbbee_status']!='NonCompliant'" class="red-asterik"> *</a>
              </label>
              <input type="number" class="form-control form-control-sm" (keypress)="numbersOnly($event)" min="0"
                     name="disability_ownership" formControlName="disability_ownership" title=""
                     [ngClass]="{'error':form.controls.disability_ownership.invalid && form.controls.disability_ownership.dirty, 'noerror': form.controls.disability_ownership.valid && form.controls.disability_ownership.dirty}">
              <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.disability_ownership.invalid && form.controls.disability_ownership.dirty">
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.disability_ownership.invalid && form.controls.disability_ownership.dirty">
                <p *ngIf="form.controls.disability_ownership.errors.required">*Required</p>
              </div>
            </div> -->
            </div>

            <div class="col-6 ln-sp ">
              <label class="control-label hd-cat lbl-align">
                % Youth Ownership<a *ngIf="isLocal  && form.value['bbbee_status']!='NonCompliant'" class="red-asterik"> *</a>
              </label>
              <input type="number" class="form-control form-control-sm" name="youth_owner" min="0"
                     (keypress)="numbersOnly($event)" formControlName="youth_owner" title=""
                     [ngClass]="{'error':form.controls.youth_owner.invalid && form.controls.youth_owner.dirty, 'noerror': form.controls.youth_owner.valid && form.controls.youth_owner.dirty}">
              <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.youth_owner.invalid && form.controls.youth_owner.dirty">
            <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.youth_owner.invalid && form.controls.youth_owner.dirty">
              <p *ngIf="form.controls.youth_owner.errors.required">*Required</p>
            </div> -->
              <!-- </div> -->
            </div>

          </div>

          <div class="row">

            <div class="col-6 ln-sp">

              <label class="control-label hd-cat lbl-align">
                Turnover Band<a *ngIf="isLocal  && form.value['bbbee_status']!='NonCompliant'" class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" formControlName="turnover_band"
                      [ngClass]="{'error': form.controls.turnover_band.invalid  && form.controls.turnover_band.dirty , 'noerror': form.controls.turnover_band.valid  && form.controls.turnover_band.dirty}">
                <option value="" selected disabled>Select turnover band</option>
                <option [ngValue]=1>Less than R1 Mil</option>
                <option [ngValue]=2>Between R1 Mil and R5 Mil</option>
                <option [ngValue]=3>Above R5 Mil</option>
              </select>
              <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.turnover_band.invalid && form.controls.turnover_band.dirty">
              <p *ngIf="form.controls.turnover_band.errors.required">*Required</p>
              </div> -->

            </div>

            <div class="col-6 ln-sp">

              <label class="control-label hd-cat lbl-align">
                Number of Employees<a *ngIf="isLocal  && form.value['bbbee_status']!='NonCompliant'" class="red-asterik"> *</a>
              </label>
              <input type="number" class="form-control form-control-sm" (keypress)="numbersOnly($event)" min="0"
                     step="1" oninput="validity.valid||(value='')" name="num_employees" formControlName="num_employees"
                     title=""
                     [ngClass]="{'error':form.controls.num_employees.invalid && form.controls.num_employees.dirty, 'noerror': form.controls.num_employees.valid && form.controls.num_employees.dirty}">
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.num_employees.invalid && form.controls.num_employees.dirty">

                <!-- <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.num_employees.invalid && form.controls.num_employees.dirty">
                <p *ngIf="form.controls.num_employees.errors.required">*Required</p>
              </div> -->

              </div>
            </div>
          </div>
        </div>

        <div class="col-12 no-mp" *ngIf="utility.isBtnVisible">
          <button title="Save & Continue to step 2" type="submit" id="btnSave"
                  class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-bottom:5px; ">
            Save & Continue
          </button>
          <button *ngIf="utility.isView" title="Cancel" (click)="utility.landingPage()" type="submit" id="btnSave"
                  class="btn btn-md m-clr pull-right hd-btn"
                  style="width:auto; margin-right:4px;margin-bottom:5px;  ">
            Cancel
          </button>
        </div>
      </form>
    </div>

  </div>
